(function () {
    'use strict';

    angular
        .module('committeeModule')
        .controller('committeeFullController', Controller);

    Controller.$inject = ['$scope', '$state', '$mdToast', 'committeeService', 'notificationService'];

    function Controller($scope, $state, $mdToast, committeeService, notificationService) {

        // Add Chair
        $scope.addChair = function (chair) {
            if (_.isUndefined($scope.boxModel.Chairs)) $scope.boxModel.Chairs = [];

            $scope.boxModel.Chairs.push(chair);
            $scope.pageIsDirty();
        }

        // Remove Member
        $scope.removeMember = function (member) {
            $scope.boxModel.Members = _.reject($scope.boxModel.Members, { ItemPersonID: member.ItemPersonID });
            $scope.pageIsDirty();
        }

        // Add Member
        $scope.addMember = function (member) {
            if (_.isUndefined($scope.boxModel.Members)) $scope.boxModel.Members = [];

            $scope.boxModel.Members.push(member);
            $scope.pageIsDirty();
        }

        // Remove Chair
        $scope.removeChair = function (chair) {
            $scope.boxModel.Chairs = _.reject($scope.boxModel.Chairs, { ItemPersonID: chair.ItemPersonID });
            $scope.pageIsDirty();
        }





        // Show Reset Action?
        $scope.showResetAction = function () {
            if (!$scope.canEdit) return false;

            return $scope.ctxtCtrl.needSaveChanges;
        };

        // Reset forms
        $scope.reset = function () {
            $scope.isLoading = true;
            $state.reload();
        }
        
        // Show Save Action
        $scope.showSaveAction = function (form) {
            if (!$scope.canEdit) return false;
            if (!$scope.boxModel.ControlID) return false;
            if (form.$invalid) return false;

            return $scope.ctxtCtrl.needSaveChanges;
        }

        // Show Add Action
        $scope.showAddAction = function (form) {
            if ($scope.boxModel.ControlID) return false;
            if (form.$invalid) return false;

            return $scope.canEdit;
        };

        // Create Or Update
        $scope.createOrUpdate = function () {
            $scope.isLoading = true;
            $scope.boxModel.ItemOrderID = $scope.boxModel.DisplayItemOrderID;

            var createOrUpdate;

            if ($scope.boxModel.CommitteeID) {
                createOrUpdate = committeeService.updateCommittee($scope.boxModel);
            } else {
                createOrUpdate = committeeService.createCommittee($scope.boxModel);
            }

            createOrUpdate
                .then(function (updatedCommittee) {

                    if (_.isUndefined($scope.boxModel.CommitteeID)) {
                        $state.go('committee', { CommitteeID: updatedCommittee.CommitteeID, SkipDirtyCheck: true });
                    }
                    else {
                        
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .content('Your changes have been saved!')
                                .position('top right')
                                .hideDelay($scope.govNotificationDelay)
                                .action('OK')
                                .theme('primary')
                        );

                        $scope.pageIsNotDirty();
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };

        // Delete
        $scope.delete = function () {

            if ($scope.boxModel.CommitteeID) {
                committeeService
                 .deleteCommittee($scope.boxModel.CommitteeID)
                 .then(function () {
                     notificationService.notify('Committee has been deleted');
                     $state.go('home', { }, {reload: true});
                 })
                 .finally(function () {
                     $scope.ctrlCtxt.isLoading = false;
                 });
            }
        }
    }

})();